const runtimePaymentUrl = window._env_ && window._env_.REACT_APP_URL_PAYMENT;

export default {
  URL: runtimePaymentUrl || process.env.REACT_APP_URL_PAYMENT || 'https://payment-gateway.dev.embrix.org/vault?callbackUrl='
};
